import axios from "axios";
import { put } from "redux-saga/effects";
import { ChatService, GetChatBotMessageResponce } from "../../../services/chat";
import { SendMessageRequestActionType } from "../types";
import { sendMessageFailure, sendMessageSuccess } from "../actionCreators";
import { IErrorType } from "../../types/errors.d";

export function* sendMessageRequestSaga({ payload }: SendMessageRequestActionType) {
    try {
        const {
            data: {
                data: { answer },
            },
        }: GetChatBotMessageResponce = yield ChatService.askToBot(payload.message);

        yield put(sendMessageSuccess({ answer }));
    } catch (e) {
        if (axios.isAxiosError(e)) {
            yield put(sendMessageFailure({ errorType: IErrorType.AXIOS, data: e }));
        } else yield put(sendMessageFailure({ errorType: IErrorType.NATIVE, data: e }));
    }
}
